import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './components/about/about.component';
import { BraziComponent } from './components/brazi/brazi.component';
import { ContactComponent } from './components/contact/contact.component';
import { DiverseComponent } from './components/diverse/diverse.component';
import { FloriComponent } from './components/flori/flori.component';
import { FotoComponent } from './components/foto/foto.component';
import { IenuparComponent } from './components/ienupar/ienupar.component';
import { MainComponent } from './components/main/main.component';
import { TujaComponent } from './components/tuja/tuja.component';



const routes: Routes = [
  { path: '', component: MainComponent },
  { path: 'tuja', component: TujaComponent },
  { path: 'brazi', component: BraziComponent },
  { path: 'ienupar', component: IenuparComponent },
  { path: 'diverse', component: DiverseComponent },
  { path: 'flori', component: FloriComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'about', component: AboutComponent },
  { path: 'foto', component: FotoComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
